module.exports = __webpack_public_path__ + "img/roboport-base-animation.5e46f3ba.png";